import BackendAPI from '~/api/BackendClient/BackendAPI'
import { components } from '~/api/BackendClient/generated-schema'

export type PlatePageResponse = components['schemas']['PlatePageResponse']

export type PlatePage_CulturePlate = components['schemas']['PlatePage_CulturePlate']
export type PlatePage_WellCulture = components['schemas']['PlatePage_WellCulture']
export type PlatePage_PlateImagingObservation =
  components['schemas']['PlatePage_PlateImagingObservation']
export type PlatePage_PlateReadObservation =
  components['schemas']['PlatePage_PlateReadObservation']

export type PlatePage_ObservationHistory =
  | PlatePage_PlateImagingObservation
  | PlatePage_PlateReadObservation

/**
 * Determines whether the provided observation is a plate imaging observation. Used for type discriminiation
 */
export function isPlateImagingObservation(
  observation: PlatePage_CulturePlate['plateObservationHistory'][number],
): observation is PlatePage_PlateImagingObservation {
  return observation.type === 'plate_imaging'
}

/**
 * Determines whether the provided observation is a plate imaging observation. Used for type discriminiation
 */
export function isPlateReadObservation(
  observation: PlatePage_CulturePlate['plateObservationHistory'][number],
): observation is PlatePage_PlateReadObservation {
  return observation.type === 'plate_read'
}

class PlatePageAPI extends BackendAPI {
  // plate_query_id is the extid by default, but also supports
  // the desktop_plate_id for backwards compatibility with the C# backend.
  getData = (plate_query_id: string): Promise<PlatePageResponse> => {
    return this.client.GET('/api/pages/plate-page/', {
      params: {
        query: { plate_query_id },
      },
    })
  }
}

export default PlatePageAPI
